import styled, { css } from "styled-components";

export const FormGroup = styled.div`
`;

export const Form = styled.form`
`;

export const Forms = styled.div`
    margin: auto;
    @media screen and (max-width: 960px){
        margin-top: 90px;
    }
`

export const Div = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const Label = styled.label`
    color: #3498DB;
    display: flex;
    justify-content: start;
    margin-left: 0px;
    margin-top: -5px;
    margin-bottom: 5px;
    font-size: 14px;
`;